import styled, { css } from 'styled-components'
import { OLIVINE, LIGHT_RED, WHITE } from 'constants/colors'
import { Flex } from 'components/common/styles'

const getChipColor = (isCompleted: boolean) =>
  isCompleted ? OLIVINE : LIGHT_RED

export const ChipWrapper = styled.div<{
  $isCompleted: boolean
  $isActive: boolean
}>`
  .MuiChip-root {
    height: 18px;
    border-radius: 4px;
    background-color: ${({ $isActive, $isCompleted }) =>
      $isActive ? getChipColor($isCompleted) : 'transparent'};
    font-size: 12px;
    font-weight: 500;
    color: ${({ $isActive, $isCompleted }) =>
      $isActive ? WHITE : getChipColor($isCompleted)};
    border: 1px solid
      ${({ $isCompleted }) => ($isCompleted ? OLIVINE : LIGHT_RED)};
    ${({ $isCompleted }) =>
      !$isCompleted &&
      css`
        margin-right: 8px;
      `};
  }
`

export const JobItemTitleDate = styled(Flex)`
  width: 100%;
  margin-right: 8px;
`

export const IconButtonWrapper = styled.div`
  padding: 0;
  margin: 0 0 0 auto;
`

export const DateTime = styled.span`
  font-weight: 500;
`

export const JobItemTitleContainer = styled(Flex)`
  font-size: 12px;
  max-height: 18px;
  line-height: 18px;
  margin-bottom: 8px;
`

export const JobItemTitleWrapper = styled.div`
  margin-bottom: 16px;
`
